import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";
import { SystemActionComponent } from "./abstract.system.action.component";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-add-candidate-action",
    template: `
        <p class="action-hint">
            The ingestion form must include an <strong>ELECTION_POSITION</strong> field; its answer supplies the
            position. Map brief text and image/URL fields below.
        </p>
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['campaignBriefField']?.inputValue"
            (valueChange)="setInputValue('campaignBriefField', $event)"
            [label]="'Campaign Brief Field'"
            [type]="'text'"
            [required]="false"
            [help]="'Field variable for candidate statement / bio (e.g. $CNET-...)'"
            [acceptedAnswerTypes]="acceptedFor('campaignBriefField')"
        />
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['photoUrlField']?.inputValue"
            (valueChange)="setInputValue('photoUrlField', $event)"
            [label]="'Photo URL Field'"
            [type]="'text'"
            [required]="false"
            [help]="'Field variable for headshot or image URL (e.g. $CNET-...)'"
            [acceptedAnswerTypes]="acceptedFor('photoUrlField')"
            [acceptedFieldTypes]="acceptedFieldTypesFor('photoUrlField')"
        />
    `,
    styles: `
        .action-hint {
            margin: 0 0 12px;
            color: #555;
            font-size: 13px;
        }

        .system-input {
            margin-bottom: 16px;
        }

        .system-input:last-child {
            margin-bottom: 0;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [WorkflowActionInputComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCandidateActionComponent extends SystemActionComponent {
    protected readonly actionCode = "ADD_CANDIDATE" as const;
}
